module.exports = __webpack_public_path__ + "img/logo_parana_225x66.f839da23.png";